// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1PdE7","paramInput":"JobSimulator_paramInput__3Ek6o","input":"JobSimulator_input__3lssl"};